/**
 * WRG Coupon Price Updater
 * Extends the variant picker to support coupon-calculated prices
 */

(function() {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    // Listen for variant change events
    document.addEventListener('variant:changed', handleVariantChange);

    // Also listen for MinimogTheme events if available
    if (window.MinimogEvents) {
      // We'll subscribe to all variant change events
      const productElements = document.querySelectorAll('variant-picker');
      productElements.forEach(picker => {
        const productId = picker.dataset.productId;
        if (productId) {
          window.MinimogEvents.subscribe(`${productId}__VARIANT_CHANGE`, handleVariantChange);
        }
      });
    }
  }

  function handleVariantChange(eventOrVariant) {
    // Handle both event object and direct variant object
    const variant = eventOrVariant.detail?.variant || eventOrVariant;

    if (!variant) return;

    // Find all coupon price elements
    const couponPriceElements = document.querySelectorAll('[data-coupon-price]');

    couponPriceElements.forEach(priceEl => {
      updateCouponPrice(priceEl, variant);
    });
  }

  function updateCouponPrice(priceEl, variant) {
    const discountType = priceEl.dataset.discountType;
    const discountAmount = parseFloat(priceEl.dataset.discountAmount);

    // If no discount data, skip
    if (!discountType || !discountAmount) return;

    const variantPrice = variant.price;
    let couponPrice = variantPrice;

    // Calculate coupon price
    if (discountType === 'percent') {
      const discountValue = Math.round(variantPrice * discountAmount / 100);
      couponPrice = variantPrice - discountValue;
    } else if (discountType === 'fiat') {
      const discountInCents = discountAmount * 100;
      couponPrice = Math.max(0, variantPrice - discountInCents);
    }

    // Update data attributes
    priceEl.dataset.originalPrice = variantPrice;
    priceEl.dataset.couponPrice = couponPrice;
    priceEl.dataset.variantId = variant.id;

    // Get money format from theme settings
    const moneyFormat = window.MinimogSettings?.money_format || '${{amount}}';

    // Update price display - only show final coupon price
    const regularPriceEl = priceEl.querySelector('[data-coupon-regular-price]');

    if (regularPriceEl) {
      regularPriceEl.innerHTML = formatMoney(couponPrice, moneyFormat);
    }

    // Update availability status
    const soldOut = !variant.available;
    priceEl.classList.toggle('m-price--sold-out', soldOut);
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || '${{amount}}';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      const parts = number.split('.');
      const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      const centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }
})();
